import React, { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import axios from "axios";
import BtnLoader from "Components/Common/Loader/BtnLoader";
import { loadDecrypted } from "Common Usage/localStorageUtils"; // <-- added

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 400,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: 8,
  boxShadow: 24,
  p: 4,
};

const RequestWarningPopup = ({
  warnPopupOpen,
  handleClose,
  warningMsg,
  requestItem,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const data = JSON.stringify({
      groupRequestAccepted: "rejected",
    });

    const config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/group-call/update/${requestItem?._id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    };

    try {
      const response = await axios.request(config);

      // ─────────────────────────────────────────────────────────
      // Create staff activity log for group request rejection
      // ─────────────────────────────────────────────────────────
      try {
        const staffData = loadDecrypted("HeartConnect-StaffData");
        const staffId = staffData?._id || staffData?.id || "";
        const staffName = staffData?.fullName || staffData?.name || "Unknown";

        if (staffId) {
          await axios.post(
            `${process.env.REACT_APP_API_URL}/staffs-activity-log/create-staffs-activity`,
            {
              staff: staffId,
              action: "REJECT_GROUP_REQUEST",
              description: `Staff ${staffName} rejected group request for group "${requestItem?.groupName}" (ID: ${requestItem?._id}) created by user ${requestItem?.createdBy?.nickName} (${requestItem?.createdBy?._id})`,
            },
            { headers: { "Content-Type": "application/json" } }
          );
        }
      } catch (logErr) {
        console.error("Failed to create staff activity log:", logErr);
      }
      // ─────────────────────────────────────────────────────────

      setIsLoading(false);
      handleClose(warningMsg); // Close the modal on success
    } catch (error) {
      console.error("API Error:", error);
      handleClose(warningMsg);
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={warnPopupOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="w-full">
          <div className="mb-4 flex items-center">
            <img
              src={requestItem?.createdBy?.selected_Avatar}
              alt="Avatar"
              className="mr-2 h-14 w-14 rounded-full"
            />
            <h2 className="text-xl font-semibold tracking-wide">
              {requestItem?.createdBy?.nickName}
            </h2>
          </div>
          <p className="mb-6 tracking-wide">
            {`Do you want to ${warningMsg} this Group request?`}
          </p>
          <div className="flex justify-end space-x-4 tracking-wide">
            <button
              className="rounded bg-gray-300 px-4 py-2 text-gray-800 hover:bg-gray-400"
              onClick={handleClose}
            >
              Cancel
            </button>
            {isLoading ? (
              <button
                className="flex w-full items-center justify-center rounded-md bg-[#c51369] p-3 font-medium text-white"
                disabled
              >
                <BtnLoader />
              </button>
            ) : (
              <button
                onClick={handleSubmit}
                className="rounded-md bg-[#c51369] p-3 font-medium text-white transition duration-200 hover:bg-[#a10f5b]"
              >
                {warningMsg}
              </button>
            )}
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default RequestWarningPopup;






// import React, { useState } from "react";
// import Box from "@mui/material/Box";
// import Modal from "@mui/material/Modal";
// import axios from "axios";
// import BtnLoader from "Components/Common/Loader/BtnLoader";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "90%",
//   maxWidth: 400,
//   bgcolor: "background.paper",
//   border: "none",
//   borderRadius: 8,
//   boxShadow: 24,
//   p: 4,
// };

// const RequestWarningPopup = ({
//   warnPopupOpen,
//   handleClose,
//   warningMsg,
//   requestItem,
// }) => {
//   const [isLoading, setIsLoading] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);

//     const data = JSON.stringify({
//       groupRequestAccepted: "rejected",
//     });

//     const config = {
//       method: "put", 
//       maxBodyLength: Infinity,
//       url: `${process.env.REACT_APP_API_URL}/group-call/update/${requestItem?._id}`,
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data,
//     };

//     try {
//       const response = await axios.request(config);
//       setIsLoading(false);
//       handleClose(warningMsg); // Close the modal on success
//     } catch (error) {
//       console.error("API Error:", error);
//       handleClose(warningMsg);
//       setIsLoading(false);
//     }
//   };

//   // console.log("requestItem requestItem ==>", requestItem);

//   return (
//     <Modal
//       open={warnPopupOpen}
//       onClose={handleClose}
//       aria-labelledby="modal-modal-title"
//       aria-describedby="modal-modal-description"
//     >
//       <Box sx={style}>
//         <div className="w-full">
//           <div className="mb-4 flex items-center">
//             <img
//               src={requestItem?.createdBy?.selected_Avatar}
//               alt="Avatar"
//               className="mr-2 h-14 w-14 rounded-full"
//             />
//             <h2 className="text-xl font-semibold tracking-wide">
//               {requestItem?.createdBy?.nickName}
//             </h2>
//           </div>
//           <p className="mb-6 tracking-wide">
//             {`Do you want to ${warningMsg} this Group request?`}
//           </p>
//           <div className="flex justify-end space-x-4 tracking-wide">
//             <button
//               className="rounded bg-gray-300 px-4 py-2 text-gray-800 hover:bg-gray-400"
//               onClick={handleClose}
//             >
//               Cancel
//             </button>
//             {isLoading ? (
//               <button
//                 className="flex w-full items-center justify-center rounded-md bg-[#c51369] p-3 font-medium text-white"
//                 disabled
//               >
//                 <BtnLoader />
//               </button>
//             ) : (
//               <button
//                 onClick={handleSubmit}
//                 className="rounded-md bg-[#c51369] p-3 font-medium text-white transition duration-200 hover:bg-[#a10f5b]"
//               >
//                 {warningMsg}
//               </button>
//             )}
//           </div>
//         </div>
//       </Box>
//     </Modal>
//   );
// };

// export default RequestWarningPopup;
